<template>
  <footer id="footer" class="jc-footer">
    <div class="jc-container">
      <div class="footer-cta">
        <div>
          <span class="jc-badge jc-badge--primary"><span class="jc-dot"></span>Ready for digital manufacturing</span>
          <h3>准备开始制造业数字化升级？</h3>
          <p>从订单、生产、仓储到设备数据，我们可以帮你梳理一套更清晰、更可落地的路径。</p>
        </div>
        <router-link class="jc-btn jc-btn--primary jc-btn--lg" to="/contactus">预约沟通</router-link>
      </div>

      <div class="jc-footer__grid">
        <div class="jc-footer__brand">
          <router-link class="jc-brand" to="/home">
            <img class="jc-brand__logo jc-brand__logo--footer" src="../assets/img/company_logo.png" alt="伟创聚点">
            <img class="jc-brand__name" src="../assets/img/name_white.png" alt="伟创聚点">
          </router-link>
          <p>杭州伟创聚点数字科技有限公司专注制造业数字化转型，为企业提供软件产品、实施服务与咨询培训。</p>
        </div>

        <div class="jc-footer__col">
          <h5>软件产品</h5>
          <ul>
            <li><router-link to="/software/order">订单管理系统</router-link></li>
            <li><router-link to="/software/mes">MES制造执行系统</router-link></li>
            <li><router-link to="/software/wms">WMS仓储管理系统</router-link></li>
            <li><router-link to="/software/device">设备云平台</router-link></li>
          </ul>
        </div>

        <div class="jc-footer__col">
          <h5>咨询培训</h5>
          <ul>
            <li><router-link to="/consulting/process">制造工艺指导</router-link></li>
            <li><router-link to="/consulting/flow">流程优化咨询</router-link></li>
            <li><router-link to="/consulting/training">管理能力培训</router-link></li>
          </ul>
        </div>

        <div class="jc-footer__col">
          <h5>联系我们</h5>
          <ul>
            <li>地址：浙江省杭州市</li>
            <li>电话：15116103906</li>
            <li>邮箱：suling@wcjudian.com</li>
            <li>微信：15116103906</li>
          </ul>
        </div>
      </div>

      <div class="jc-footer__bottom">
        <span>Copyright &copy; 2018 - {{ new Date().getFullYear() }} 杭州伟创聚点数字科技有限公司</span>
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer">浙ICP备2026050609号</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>

<style scoped>
#footer {
  width: 100%;
}

.footer-cta {
  margin-top: -32px;
  margin-bottom: 72px;
  padding: 34px 40px;
  border: 1px solid color-mix(in srgb, var(--jc-primary) 28%, transparent);
  border-radius: 22px;
  background:
    radial-gradient(circle at 12% 0%, rgba(31, 224, 200, 0.22), transparent 38%),
    linear-gradient(135deg, rgba(14, 42, 71, 0.92), rgba(35, 91, 126, 0.5));
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.32), 0 0 0 1px rgba(31, 224, 200, 0.08) inset;
}

.footer-cta h3 {
  color: #fff;
  font-size: 30px;
  margin: 12px 0 10px;
}

.footer-cta p {
  color: #cbd5e1;
  max-width: 620px;
  margin: 0;
}

/* 深色横幅上的 CTA 按钮：默认主题渐变起点(#0E2A47)与横幅背景同色会"隐身"，
   改用高对比实色——亮青底 + 白色字 */
.footer-cta .jc-btn {
  --_bg: #1FE0C8;
  --_fg: #FFFFFF;
  border: none;
  font-weight: 700;
  box-shadow: 0 10px 28px rgba(31, 224, 200, 0.28);
}
.footer-cta .jc-btn:hover,
.footer-cta .jc-btn:focus {
  --_bg: #3BEAD4;
  --_fg: #FFFFFF;
  box-shadow: 0 14px 34px rgba(31, 224, 200, 0.42);
}

.jc-footer__col li {
  color: #9fb0c3;
}

@media (max-width: 768px) {
  .footer-cta {
    padding: 26px;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 48px;
  }

  .footer-cta h3 {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue